import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  orderListLoading: false,
  orderListSuccess: null,
  orderListError: '',
  orderHistoryLoading: false,
  orderHistorySuccess: null,
  orderHistoryError: '',
}

export const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    setOrderListLoading: (state, action) => {
      state.orderListLoading = true;
      state.orderListSuccess = null;
      state.orderListError = '';
    },
    setOrderListSuccess: (state, action) => {
      state.orderListLoading = false;
      state.orderListSuccess = action.payload;
      state.orderListError = '';
    },
    setOrderListError: (state, action) => {
      state.orderListLoading = false;
      state.orderListSuccess = null;
      state.orderListError = action.payload;
    },
    setOrderHistoryLoading: (state, action) => {
      state.orderHistoryLoading = true;
      state.orderHistorySuccess = null;
      state.orderHistoryError = '';
    },
    setOrderHistorySuccess: (state, action) => {
      state.orderHistoryLoading = false;
      state.orderHistorySuccess = action.payload;
      state.orderHistoryError = '';
    },
    setOrderHistoryError: (state, action) => {
      state.orderHistoryLoading = false;
      state.orderHistorySuccess = null;
      state.orderHistoryError = action.payload;
    }
  },
})

// Action creators are generated for each case reducer function
export const { setOrderListLoading, setOrderListSuccess, setOrderListError,setOrderHistoryError, setOrderHistoryLoading, setOrderHistorySuccess  } = ordersSlice.actions

export default ordersSlice.reducer;